import React from "react";
import { Grid } from "@mui/material";
import LabeledText from "../../Widgets/LabeledText";
import { CriminalHistoryFormValues } from "./interface";

interface ViewFieldsProps {
  formValues: CriminalHistoryFormValues;
}

export const ViewFields: React.FC<ViewFieldsProps> = ({ formValues }) => {
  return (
    <Grid container sx={{ rowGap: "24px" }}>
      <LabeledText
        label="Is the client or anyone in the home, under the influence of drugs or alcohol? If yes, explain & note if any treatment measures have taken place"
        value={formValues.drugAlcoholUse}
      />

      <LabeledText
        label="Does the client or anyone in the home have any current/past criminal charges filed, or completed time in jail? If yes, explain."
        value={formValues.criminalLegalHistory}
      />
    </Grid>
  );
};

export default ViewFields;
